// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.att-scan-dialog-backdrop {
  position: fixed;
  inset: 0;
  z-index: 12000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(30, 30, 40, 0.58);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  animation: attScanBackdropIn 0.2s ease-out;
}

.att-scan-dialog {
  --att-scan-color: #2e9d68;
  --att-scan-light: #e5f6ed;

  position: relative;
  width: 100%;
  max-width: 420px;
  padding: 42px 34px 28px;
  border-radius: 22px;
  background: #fdfbf8;
  text-align: center;
  box-shadow:
    0 24px 70px rgba(0, 0, 0, 0.18),
    0 6px 20px rgba(0, 0, 0, 0.08);
  animation: attScanModalIn 0.25s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.att-scan-dialog.is-success {
  --att-scan-color: #2e9d68;
  --att-scan-light: #e5f6ed;
}

.att-scan-dialog.is-error {
  --att-scan-color: #d9534f;
  --att-scan-light: #fde9e8;
}

.att-scan-dialog.is-info {
  --att-scan-color: #5c61c9;
  --att-scan-light: #ecebff;
}

.att-scan-dialog__icon {
  width: 78px;
  height: 78px;
  margin: 0 auto 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--att-scan-light);
  color: var(--att-scan-color);
  box-shadow:
    0 0 0 8px rgba(255, 255, 255, 0.7),
    0 8px 20px rgba(0, 0, 0, 0.06);
}

.att-scan-dialog__icon svg {
  width: 38px;
  height: 38px;
}

.att-scan-dialog__message {
  margin: 0;
  color: #2f2f35;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.45;
  letter-spacing: -0.2px;
  word-break: break-word;
}

.att-scan-dialog__message--name {
  font-size: 32px;
  font-weight: 800;
  line-height: 1.3;
  letter-spacing: -0.4px;
}

.att-scan-dialog__progress {
  width: 100%;
  height: 4px;
  margin-top: 28px;
  overflow: hidden;
  border-radius: 999px;
  background: #ece9e5;
}

.att-scan-dialog__progress-bar {
  width: 100%;
  height: 100%;
  background: var(--att-scan-color);
  transform-origin: left center;
  animation: attScanProgress linear forwards;
}

@keyframes attScanBackdropIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes attScanModalIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes attScanProgress {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0);
  }
}

@media (max-width: 576px) {
  .att-scan-dialog {
    padding: 36px 22px 24px;
    border-radius: 18px;
  }

  .att-scan-dialog__icon {
    width: 68px;
    height: 68px;
  }

  .att-scan-dialog__icon svg {
    width: 32px;
    height: 32px;
  }

  .att-scan-dialog__message {
    font-size: 20px;
  }

  .att-scan-dialog__message--name {
    font-size: 28px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .att-scan-dialog-backdrop,
  .att-scan-dialog,
  .att-scan-dialog__progress-bar {
    animation: none;
  }

  .att-scan-dialog__progress-bar {
    transform: scaleX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AttendanceScanDialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;;EAEzB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB;;kCAEgC;EAChC,8DAA8D;AAChE;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,4BAA4B;EAC5B;;kCAEgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;IAGE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".att-scan-dialog-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 12000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(30, 30, 40, 0.58);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  animation: attScanBackdropIn 0.2s ease-out;\n}\n\n.att-scan-dialog {\n  --att-scan-color: #2e9d68;\n  --att-scan-light: #e5f6ed;\n\n  position: relative;\n  width: 100%;\n  max-width: 420px;\n  padding: 42px 34px 28px;\n  border-radius: 22px;\n  background: #fdfbf8;\n  text-align: center;\n  box-shadow:\n    0 24px 70px rgba(0, 0, 0, 0.18),\n    0 6px 20px rgba(0, 0, 0, 0.08);\n  animation: attScanModalIn 0.25s cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n\n.att-scan-dialog.is-success {\n  --att-scan-color: #2e9d68;\n  --att-scan-light: #e5f6ed;\n}\n\n.att-scan-dialog.is-error {\n  --att-scan-color: #d9534f;\n  --att-scan-light: #fde9e8;\n}\n\n.att-scan-dialog.is-info {\n  --att-scan-color: #5c61c9;\n  --att-scan-light: #ecebff;\n}\n\n.att-scan-dialog__icon {\n  width: 78px;\n  height: 78px;\n  margin: 0 auto 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: var(--att-scan-light);\n  color: var(--att-scan-color);\n  box-shadow:\n    0 0 0 8px rgba(255, 255, 255, 0.7),\n    0 8px 20px rgba(0, 0, 0, 0.06);\n}\n\n.att-scan-dialog__icon svg {\n  width: 38px;\n  height: 38px;\n}\n\n.att-scan-dialog__message {\n  margin: 0;\n  color: #2f2f35;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.45;\n  letter-spacing: -0.2px;\n  word-break: break-word;\n}\n\n.att-scan-dialog__message--name {\n  font-size: 32px;\n  font-weight: 800;\n  line-height: 1.3;\n  letter-spacing: -0.4px;\n}\n\n.att-scan-dialog__progress {\n  width: 100%;\n  height: 4px;\n  margin-top: 28px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #ece9e5;\n}\n\n.att-scan-dialog__progress-bar {\n  width: 100%;\n  height: 100%;\n  background: var(--att-scan-color);\n  transform-origin: left center;\n  animation: attScanProgress linear forwards;\n}\n\n@keyframes attScanBackdropIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes attScanModalIn {\n  from {\n    opacity: 0;\n    transform: translateY(12px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes attScanProgress {\n  from {\n    transform: scaleX(1);\n  }\n  to {\n    transform: scaleX(0);\n  }\n}\n\n@media (max-width: 576px) {\n  .att-scan-dialog {\n    padding: 36px 22px 24px;\n    border-radius: 18px;\n  }\n\n  .att-scan-dialog__icon {\n    width: 68px;\n    height: 68px;\n  }\n\n  .att-scan-dialog__icon svg {\n    width: 32px;\n    height: 32px;\n  }\n\n  .att-scan-dialog__message {\n    font-size: 20px;\n  }\n\n  .att-scan-dialog__message--name {\n    font-size: 28px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .att-scan-dialog-backdrop,\n  .att-scan-dialog,\n  .att-scan-dialog__progress-bar {\n    animation: none;\n  }\n\n  .att-scan-dialog__progress-bar {\n    transform: scaleX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
